<template>
  <v-progress-linear indeterminate color="primary" height="3"></v-progress-linear>
</template>
<script>
export default {
  name: "TableLoader"
};
</script>



// WEBPACK FOOTER //
// src/components/TableLoader.vue